import App from '@/App.vue';
import '@/plugins/axios';
import '@/registerServiceWorker';
import router from '@/router';
import store from '@/store/store';
import Vue from 'vue';

import Vuelidate from 'vuelidate';
import Vuetify from 'vuetify';

import AdminCredentiaModule from '@/store/modules/AdminCredentialModule';
import _ from 'lodash';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify/dist/vuetify.min.css';
import { getModule } from 'vuex-module-decorators';

Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(Vuetify);

const adminCredentialModule = getModule(AdminCredentiaModule);
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !adminCredentialModule.jwt) {
    next('/login');
  }

  next();
});

export const upsertList = <T>(arr: T[], key: string, newvals: T[]) => {
  _.each(newvals, ($0: any) => {
    upsert(arr, { [key]: $0[key] }, $0);
  });
};

export const upsert = <T>(arr: T[],
                          key: string | number | symbol |
                               [string | number | symbol, any] |
                               _.ListIterator<T, boolean> | _.PartialDeep<T> | undefined,
                          newval: T) => {
  const index = _.findIndex(arr, key);
  if (index >= 0) {
    arr.splice(index, 1, _.cloneDeep(newval));
  } else {
    arr.push(newval);
  }
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
